<style lang="scss" scoped>
  .container {
    margin: 0 auto;
    padding: 0 20px;
    width: 1060px;
    max-width: 100%;
  }

  .footer-content {
    position: relative;
    padding: 70px 0 72px 525px;

    &:before {
      content: '';
      position: absolute;
      top: -52px;
      left: -90px;
      width: 560px;
      height: 488px;
      background: cdn('images/b2b/footer/footer-bg.png') no-repeat center;
      background-size: 100% auto;

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/footer/footer-bg@2x.png');
      }
    }

    [dir=rtl] & {
      padding: 70px 525px 72px 0;

      &:before {
        left: auto;
        right: -90px;
        transform: scaleX(-1);
      }
    }

    @include media(max, lg) {
      padding: 276px 20px 62px;
      text-align: center;

      &:before {
        top: -75px;
        left: 50%;
        width: 403px;
        height: 396px;
        transform: translateX(-50%);
      }

      [dir=rtl] &:before {
        left: 50%;
        right: auto;
        transform: translateX(-50%) scaleX(-1);
      }
    }
  }

  .title {
    position: relative;
    z-index: 1;
    margin: 0 0 30px;
    font-weight: 600;
    font-size: 44px;
    line-height: 1.09;

    @include media(max, lg) {
      font-size: 32px;
      line-height: 1.12;
      text-align: left;
    }
  }

  .btn-wrapper {
    position: relative;
    z-index: 1;
    margin-bottom: 32px;
  }

  .btn-action {
    padding: 12px 20px;
    line-height: 32px;
    background-color: #e2e3e7;
    border-radius: 10px;

    [dir=rtl] & {
      svg {
        transform: rotate(180deg);
      }
    }

    @include media(max, md) {
      width: 100%;
    }
  }

  .overview-link {
    position: relative;
    z-index: 1;
    font-size: 18px;
    line-height: 1.78;
    color: #fff;

    svg {
      display: inline-block;
      vertical-align: -4px;
    }

    [dir=rtl] & {
      svg {
        transform: rotate(180deg);
      }
    }
  }
</style>

<template>
  <div class="container">
    <div class="footer-content">
      <h2 class="title">
        {{$t('title')}}
      </h2>
      <div class="btn-wrapper">
        <btn
          href="/dev/developers/register/"
          target="_blank"
          variant="secondary"
          class="fs-18 btn-main btn-action">
          {{$t('btnText')}}
          <icon name="angle"/>
        </btn>
      </div>

      <a href="//documentation.vkplay.ru/overview_vkp/platform_overview_vkp" class="overview-link">
        {{$t('overview')}}
        <icon name="angle"/>
      </a>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */

export default {
  name: 'Footer',
  i18n: {
    messages: {
      ru: {
        title: 'Давайте развивать игровую индустрию вместе!',
        overview: 'Обзор всех возможностей',
        btnText: 'Кабинет разработчика',
      },
      en: {
        title: 'Let\'s develop the game industry together!',
        overview: 'An overview of all features',
        btnText: 'Developer Dashboard',
      },
      de: {
        title: 'Lass uns die Spieleindustrie gemeinsam weiterentwickeln! ',
        overview: 'Eine Übersicht über alle Funktionen',
        btnText: 'Entwickler-Dashboard',
      },
      fr: {
        title: 'Développons ensemble l\'industrie du jeu !',
        overview: 'Un aperçu de toutes les fonctionnalités',
        btnText: 'Tableau de bord des développeurs',
      },
      es: {
        title: '¡Desarrollemos juntos la industria del videojuego!',
        overview: 'Un resumen de todas las características',
        btnText: 'Tablón de desarrolladores',
      },
      pl: {
        title: 'Wspólnie rozwijajmy przemysł gier!',
        overview: 'Przegląd wszystkich funkcji',
        btnText: 'Pulpit twórcy',
      },
      tr: {
        title: 'Hadi, oyun endüstrisini birlikte geliştirelim!',
        overview: 'Tüm özelliklere genel bakış',
        btnText: 'Geliştirici Paneli',
      },
      ar: {
        title: 'لنطور صناعة الألعاب بتعاوننا!',
        overview: 'نظرة عامة على جميع الميزات',
        btnText: 'لوحة تحكم المطور',
      },
    },
  },
};

</script>
